import React, { PureComponent, Component } from 'react';
import CheckDefecto from '../../../../Common/Components/CheckDefecto'
import SelectWithLabel from '../../../../Common/Components/SelectWithLabel'

class Cierre extends Component {
    constructor(props) {
        super(props)
        this.state = {
            DiasRespectoAlCierre: props.data.DiasRespectoAlCierre
        };
        this.selectRadio = this.selectRadio.bind(this);
    }


    selectRadio(name, value) {
        this.props.selectRadio(name, value)
    }

    onChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);
        const maxVal = dataset.maxval;
                
        if(value == "" || (regExp.test(value) && (!maxVal || parseInt(value)<=parseInt(maxVal)))) {
            let newState = {
                [dataset.code]: value
            }
            
            this.setState(newState);
            this.props.changeInput(dataset.code, value);
        }
    }

    onBlur(event) {
        const { value, dataset } = event.target;
        
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            DiasRespectoAlCierre: nextProps.data.proceso.Periodicidad == "Cierre" ? nextProps.data.DiasRespectoAlCierre : ""
        });
    }

    render() {

        const { proceso, calendario, carteras, esDiaPositivo, ERROR_PROCESS } = this.props.data;
        let disabled = (proceso.Periodicidad != "Cierre");
        const classBase = `container-radio${((disabled) ? "-disabled" : "")} radio-margin`;
        let optionCarteras = [];

        if(carteras && carteras.length > 0){
            optionCarteras = carteras.map((cartera, index) => {
                return (
                    <option value={cartera.Id} key={"cartera-option-" + index} data-codigo={cartera.Codigo}>
                        {cartera.Descripcion}
                    </option>
                );
            });
        }        
        
        return (
            <div className="row top-separator-xs" style={{marginLeft:"20px"}}>
                <div className="row">
                    <div className="col-xs-3">
                        <div className="row row-radio">
                            <div className="col-xs-10">
                                <div className="container-radio radio-margin">
                                    <input id={"rbCierreCartera" + 1}
                                        type="radio"
                                        name="rbCierreCartera"
                                        data-value={"Cierre"}
                                        value={true}
                                        checked={proceso.Periodicidad == "Cierre"}
                                        onChange={(event) => this.selectRadio("Periodicidad", event.target.dataset.value)}
                                    />

                                    <label
                                        className="lbl-radio label-secondary"
                                        htmlFor={"rbCierreCartera" + 1}>
                                        {"Relativo al cierre de cartera"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* CARTERA */}
                    <div className="col-xs-12 bottom-separator-xs" style={{marginLeft:"25px"}}>
                        <SelectWithLabel
                            mensajeError={null}
                            options={optionCarteras}
                            seleccionarCombo={this.props.seleccionarCombo}
                            value={calendario.CarteraId}
                            disabled={proceso.Periodicidad != "Cierre"}
                            nombreCombo="CARTERAS"
                            titulo="Cartera"
                            short={true}
                        />
                    </div>
                    {/* CARTERA */} 

                    {/* DIAS CON RESPECTO AL CIERRE */}
                    <div className="col-xs-3" style={{right:"0px"}}>
                        <label className="lbl-radio label-secondary">{"Días respecto al cierre"}</label>
                    </div>

                     <div className="col-xs-1" style={{marginLeft:"0px"}}>
                        <input className="form-control form-control-tarjetas input-Short"
                            maxLength={2}
                            value={this.state.DiasRespectoAlCierre}
                            data-code="DiasRespectoAlCierre"
                            data-validation="^[0-9]{0,2}$"
                            data-maxVal="31"
                            disabled={proceso.Periodicidad != "Cierre"}
                            onChange={this.onChange.bind(this)}
                            //onBlur={this.onBlur.bind(this)}
                        />
                    </div> 
 
                    <div className="col-xs-8">
                    </div>

                    {/* // DIAS CON RESPECTO AL CIERRE  */}



                    {/* ANTES DEL CIERRE */}

                    <div className="col-xs-12" style={{marginLeft:"29px"}}> 
                        <div className={classBase}>
                            <input id={"rbAntesCierre" + 1}
                                type="radio"
                                name="rbAntesCierre"
                                value={true}
                                // disabled={true}
                                data-value={"AntesCierre"}
                                checked={esDiaPositivo == false}
                                onChange={(event) => this.selectRadio("esDiaPositivo", false)}
                                 />
                            />
                               <label
                                style={{marginLeft:"10px"}}
                                className="lbl-radio label-secondary"
                                htmlFor={"rbAntesCierre" + 1}>
                                {"Antes del cierre"}
                            </label>
                        </div>
                    </div>

                    {/* ANTES DEL CIERRE */}
                    {/* DESPUES DEL CIERRE */}
                    <div className="col-xs-12" style={{marginLeft:"29px"}}> 
                        <div className={classBase}>
                            <input id={"rbDespuesCierre" + 2}
                                type="radio"
                                name="rbDespuesCierre"
                                value={true}
                                // disabled={true}
                                data-value={"DespuesCierre"}
                                checked={esDiaPositivo == true}
                                onChange={(event) => this.selectRadio("esDiaPositivo", true)} 
                                />
                            />
                               <label
                                style={{marginLeft:"10px"}}
                                className="lbl-radio label-secondary"
                                htmlFor={"rbDespuesCierre" + 2}>
                                {"Después del cierre"}
                            </label>
                        </div>
                    </div>
                    {/*  DESPUES DEL CIERRE */}


                </div>

                {/* CONTAR SOLO LOS DIAS */} 
                <CheckDefecto
                    style={{marginLeft:"26px"}}
                    nombre={"Contar solo Días Hábiles"}
                    referencia={"DiasHabiles" + 4}
                    id={"DiasHabiles" + 4}
                    activo={proceso.Periodicidad == "Cierre"}
                    check={calendario.DiaHabil && proceso.Periodicidad == "Cierre"}
                    selectCheckBox={(event) => this.props.setCheck("DiaHabil", event.target.checked)}
                /> 

                {!ERROR_PROCESS["seleccionoCierre"] && proceso.Periodicidad == "Cierre" &&
                    <label className="error">{"Se debe seleccionar la cartera y completar los días con respecto al cierre."}</label>}

            </div>

        )
    }
};

export default Cierre;